import React from 'react';
import cx from 'classnames';

import { tabNavigatorContext } from './TabNavigatorContext';

export function TabContent(props) {
  const { className, children, show = true, hide = false, index } = props;

  const [activeIndex] = tabNavigatorContext();

  const containerClassName = cx('tab-content', className);

  /*
    Initially checking the priority flags
    After checking the index matching
  */
  const hidden = show === false || hide === true || activeIndex !== index;

  if (hidden) {
    return null;
  }

  return <div className={containerClassName}>{children}</div>;
}
